export enum WithdrawalMethodsEnum {
    CARD = 'card',
    RU_CARD = 'ru_card',
    PAYPAL = 'paypal',
    GIFTCARD = 'giftCard'
}
